import { render } from "./verstock.vue?vue&type=template&id=099ad61e&scoped=true"
import script from "./verstock.vue?vue&type=script&lang=js"
export * from "./verstock.vue?vue&type=script&lang=js"

import "./verstock.vue?vue&type=style&index=0&id=099ad61e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099ad61e"]])

export default __exports__